import axios from "axios"

export const getAll = () => {
  return axios.get(`/api/crmAccounts/getAll`)
}

export const savePermissions = (crmAccountPermissions) => {
  return axios.post(`/api/crmAccounts/savePermissions`, {
    data: crmAccountPermissions
  })
}

export const getRolesForCrmAccount = (crmAccountId) => {
  return axios.get(`/api/crmAccounts/getRolesForCrmAccount?id=${crmAccountId}`).then((response) => response.data)
}
